import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {createDialog, QuestionDialog } from "coaz-ui";
import { GlobalContext } from "../contexts/GlobalContext";
import client from "../client";

const Card = ({
	id,
	image,
	heading,
	body,
	onOpen,
	actionText,
	onAction,
	completionPercentage
}) => {

	return (
		<div className="flex flex-col w-80 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white">
			<div
				onClick={onOpen ? (e) => onOpen(e, id) : undefined}
				style={{ height: (9 * 320) / 16 + "px" }}
				className={`relative w-full ${onOpen && "cursor-pointer"}`}
			>
				<img
					src={image}
					alt={heading}
					className="w-full h-full object-cover"
				/>
				{completionPercentage != null && (
					<div className="absolute left-0 right-0 bottom-0 h-1 bg-white/20">
						<div
							style={{ width: completionPercentage + "%" }}
							className="h-full bg-[#55a2dc] transition-all duration-500"
						/>
					</div>
				)}
			</div>
			<div className="w-full p-4">
				<p className="font-bold text-[#16365c] text-sm mb-2 w-full max-h-10 line-clamp-2 capitalize">
					{heading? heading:""}
				</p>
				<p className="text-[#7c8a97] text-xs mb-3 w-full max-h-16 line-clamp-3">
					{body?body:""}
				</p>
				<div className="flex flex-row items-center justify-between w-full h-5">
					<p className="text-[#1477c2] text-xs font-semibold">
						{completionPercentage != null ? `Completion ${completionPercentage}%` : ""}
					</p>
					{actionText && onAction && (
						<button
							type="button"
							onClick={onAction ? (e) => onAction(e,id) : undefined}
							aria-label={actionText}
							className="text-[#1477c2] text-xs font-semibold hover:text-[#16365c] transition"
						>
							{actionText}
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default Card